import React from "react";
import "./index.css";

function Privacy_Content() {
  return (
    <>
      {/* <div class="container text-start mb-5">
        <h6 className="privacy-header">Overview</h6>
        <p className="privacy-content">
          We may collect personal identification information from Users in a
          variety of ways, including, but not limited to, when Users visit our
          site, subscribe to the newsletter, fill out a form, and in connection
          with other activities, services, features or{" "}
          <a href="/" className="text-decoration-none" style={{color:"#00adef"}}>
            resources
          </a>{" "}
          we make available on our Site. Users may be asked for, as appropriate,
          name, email address, mailing address, phone number, company name. We
          will collect personal <strong>identification</strong> information from
          Users only if they voluntarily consent such information to us. Users
          can always refuse to supply personally identification information,
          except that it may prevent them from engaging in certain Site related
          activities.
        </p>
        <h5 className="privacy-header-2">
          General Permission To Use And Access And Use Limitations
        </h5>
        <p className="privacy-content">
          This site is provided by <strong>Izan</strong>. <strong>Izan</strong>{" "}
          collects information in several ways from different parts of this
          site.
        </p>
        <ul className="privacy-ul">
          <li className="privacy-li">
            <span className="privacy-li-no">1.</span> Complimentary ground
            shipping within 1 to 7 business days.
          </li>
          <li className="privacy-li">
            <span className="privacy-li-no">2.</span> In-store collection
            available within 1 to 7 business days.
          </li>
          <li className="privacy-li">
            <span className="privacy-li-no">3.</span> Next-day and Express
            delivery options also available.
          </li>
          <li className="privacy-li">
            <span className="privacy-li-no">4.</span> See the delivery FAQs for
            details on shipping methods, costs and delivery times
          </li>
        </ul>
        <h4 className="privacy-header-3">Confidential Information</h4>
        <p className="privacy-content">
          <strong>Izan</strong> accepts the following payment methods:
        </p>
        <ul class="privacy-ul">
          <li className="privacy-li2">
            Credit Card: <strong>Visa</strong>, <strong>MasterCard</strong>,{" "}
            <strong>Discover</strong>, <strong>American Express</strong>. The
            total will be charged to your card when the order is shipped.
          </li>
          <li className="privacy-li2">
            <strong>Izan</strong> features a Fast Checkout option, allowing you
            to securely save your credit card details so that you don't have to
            re-enter them for future purchases.
          </li>
        </ul>
        <h3 className="privacy-header-4">Linking To This Site</h3>
        <p className="privacy-content">
          Items returned within 14 days of their original shipment date in same
          as new condition will be eligible for a full refund or store credit.
          Refunds will be charged back form of payment used for purchase.
          Customer is responsible for shipping charges when making returns and
          shipping/handling fees of original purchase is non-refundable.
        </p>
        <h2 className="privacy-header-5">Intellectual Property</h2>
        <p className="privacy-content">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eget
          euismod erat, sit amet vulputate enim. Etiam enim tellus, maximus vel
          augue sed, pharetra hendrerit orci. Vivamus sed massa in nibh
          imperdiet mattis quis sed augue. Pellentesque erat metus, vestibulum
          nec nisl.
        </p>
        <p className="privacy-content">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eget
          euismod erat, sit amet vulputate enim. Etiam enim tellus.
        </p>
        <h1 className="privacy-header-6">Security And Storage</h1>
        <p className="privacy-content">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eget
          euismod erat, sit amet vulputate enim. Etiam enim tellus.
        </p>
        <ul className="privacy-ul">
          <li className="privacy-li">
            <span className="privacy-li-no">1.</span> Credit Card:{" "}
            <strong>Visa</strong>, <strong>MasterCard</strong>,{" "}
            <strong>Discover</strong>, <strong>American Express</strong>. The
            total will be charged to your card when the order is shipped.
          </li>
          <li className="privacy-li">
            <span className="privacy-li-no">2.</span> <strong>Izan</strong>{" "}
            features a Fast Checkout option, allowing you to securely save your
            credit card details so that you don't have to re-enter them for
            future purchases.
          </li>
        </ul>
      </div> */}
      <div className="container text-start mb-5">
        <h6 className="privacy-header">Overview :</h6>
        <p className="privacy-content">
          At{" "}
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "#00adef" }}
          >
            Hermon Solutions
          </a>
          , we understand the importance of protecting your personal
          information. As a leading IT development company, our clients, website
          visitors, and partners entrust us with sensitive data during
          interactions such as project inquiries, service requests, and
          consultations. We are committed to maintaining your trust and
          safeguarding your information through strict data handling practices,
          secure development protocols, and full transparency in how your data
          is used. This Privacy Policy explains how{" "}
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "#00adef" }}
          >
            Hermon Solutions
          </a>{" "}
          collects, uses, protects, and shares your information when you use our
          website or engage our services.
        </p>
        <p className="privacy-content">
          When you visit our website or communicate with us through our contact
          forms, chat support, or email, we may collect personal information
          including your name, email address, phone number, company details, and
          project requirements. If you decide to engage with us for services
          such as website design, mobile app development, backend API
          development, UI/UX consulting, cloud deployment, or DevOps
          integration, we may require more detailed business or technical
          information to successfully fulfill the project. This may include your
          preferred technology stack, access credentials (shared with your
          permission), and internal requirements documentation. All data shared
          with us is treated with the highest level of confidentiality.
        </p>
        <p className="privacy-content">
          Our systems may also automatically capture technical details such as
          your device type, browser version, time of visit, duration on site,
          and referral sources. We use tools like Google Analytics, Meta Pixel,
          and LinkedIn Insights Tag to help us understand visitor behavior,
          track campaign effectiveness, and enhance the user experience. These
          analytics tools may use cookies, small text files stored on your
          device, to anonymously track usage patterns and optimize website
          performance. By continuing to use our website, you consent to our use
          of cookies in accordance with this Privacy Policy.
        </p>
        <p className="privacy-content">
          The information we collect enables us to analyze user behavior,
          respond to service inquiries, send accurate proposals, deliver
          custom-built software, issue invoices, provide post-launch support,
          and maintain long-term relationships. For marketing purposes, we may
          also use your contact information to send occasional updates about our
          services, product launches, technical blogs, or offers related to our
          work in web, app, and software development. However, you are always in
          control of your preferences, and you can opt out from promotional
          communications at any time.
        </p>
        <h5 className="privacy-header-2">
          General Permission To Use And Access And Use Limitations :
        </h5>
        <p className="privacy-content">
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "#00adef" }}
          >
            Hermon Solutions
          </a>{" "}
          uses advanced security practices to ensure your data is protected
          against unauthorized access, breaches, or misuse. This includes SSL
          encryption for all data transfers, firewalls and malware detection on
          our servers, access restrictions based on role hierarchy, code
          vulnerability checks, and secure cloud storage via industry leaders
          such as AWS, Azure, or Google Cloud. We also conduct regular backups,
          data recovery simulations, and internal audits to ensure our systems
          are secure and compliant.
        </p>
        <p className="privacy-content">
          We only share your information with third-party providers when
          absolutely necessary to complete a service you’ve requested. This may
          include domain registrars, email service providers, cloud storage
          vendors, payment gateways, and security auditors. All third-party
          partners we work with are either GDPR-compliant or adhere to global
          data protection laws. We will never sell your information or use it
          for purposes unrelated to our services without your explicit consent.
        </p>
        <p className="privacy-content">
          If you are a business client, your project files, website data, app
          databases, and user content are stored in protected environments and
          only accessed by our assigned development teams under strict NDAs. We
          treat your intellectual property with full confidentiality and use
          secure Git repositories, authenticated staging servers, and encrypted
          file-sharing protocols to exchange code and content throughout the
          project life cycle.
        </p>
        <p className="privacy-content">
          For clients located in the European Union, United States, or other
          regions with specific data protection laws like the General Data
          Protection Regulation (GDPR) or California Consumer Privacy Act
          (CCPA), we ensure full compliance with those laws. This means you have
          rights such as accessing the data we hold about you, requesting
          corrections, withdrawing consent, and even requesting deletion of all
          your stored data. To make any such request, simply contact us at
          contact@hermonsolution.com, and we will respond within the legally
          required timeframe.
        </p>
        <p className="privacy-content">
          {" "}
          As part of our development process, we may temporarily access
          platforms or services that you use, such as CMS systems, hosting
          panels, email marketing tools, or third-party plugins. This access is
          solely for technical setup, configuration, or issue resolution, and
          all credentials are stored securely and deleted after project
          completion or as instructed by the client. If required, we are open to
          signing NDAs and third-party data confidentiality agreements for your
          peace of mind.
        </p>
        <p className="privacy-content">
          In scenarios where you provide us user data or customer information
          (e.g., for e-commerce site testing, CRM setup, or migration projects),
          we request that such data be anonymized where possible. If not, we
          ensure it is handled with the same level of care and security as your
          business information. We never retain user data after delivery unless
          required for maintenance or long-term hosting.
        </p>
        <p className="privacy-content">
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "#00adef" }}
          >
            Hermon Solutions
          </a>{" "}
          does not knowingly collect or store data from users under the age of
          18. Our services are designed for professionals, businesses, and
          enterprises. If we discover that we’ve unknowingly collected
          information from a minor, we will promptly delete it from our records
          and systems. This Privacy Policy also applies to any subdomains,
          service platforms, API portals, or documentation spaces hosted under{" "}
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "#00adef" }}
          >
            Hermon Solutions
          </a>
          . Our policy ensures that even if we provide access to staging or demo
          environments, those are also governed under this agreement. We strive
          to keep your business and user information safe during every phase of
          the software development lifecycle.
        </p>
         <h5 className="privacy-header-2">
          Conclusion :
        </h5>
        <p className="privacy-content">
          We may update this Privacy Policy periodically to reflect changes in
          our services, technology, or compliance requirements. Updates will be
          posted on this page with the revised effective date at the top. We
          encourage users to review this policy regularly. Continued use of our
          website or services after policy updates constitutes acceptance of the
          new terms. If you have any concerns, questions, or feedback about our
          privacy practices or would like to lodge a complaint, you may contact
          us directly. Our dedicated privacy officer will ensure that your
          concerns are addressed promptly and professionally. At Hermon
          Solutions, we believe that your trust is earned by our actions not
          just our words. Whether you are a startup, SME, or enterprise client,
          your privacy and data security are our priority. From discovery to
          deployment, and beyond into support and scaling, we handle every piece
          of your project with transparency and integrity.
        </p>
      </div>
    </>
  );
}

export default Privacy_Content;
